import React from 'react'
import style from './index.module.sass'

export const EditModeTitle = () => {
	return (
		<div className={style.titleRow}>
			<div className={style.title}>Edit Schedules</div>
		</div>
	)
}
